import { AiOutlineClose } from "react-icons/ai";

interface modalProps {
  children?: any;
  title?: string;
  extraFunctions?: any;
  setPopupOpen?: any;
  style?: any;
  isCloseHidden?: boolean;
  status?: any;
  setReservationState?: any;
}

const WalletModal = ({
  children,
  title,
  extraFunctions,
  setPopupOpen,
  isCloseHidden,
  setReservationState,
  style = { width: "643px" },
}: modalProps) => {
  return (
    <div className="modal-overlay">
      <div className="outline-modal-wrapper">
        <div className="modal-wrapper" style={style}>
          {!isCloseHidden && (
            <AiOutlineClose
              className="modal-close-btn"
              onClick={() => {
                setPopupOpen(false);
                if (setReservationState) {
                  setReservationState(true);
                  setTimeout(() => {
                    setReservationState(false);
                  }, 5000);
                }
                if (extraFunctions) {
                  extraFunctions();
                }
              }}
              color="var(--white)"
              size={20}
            />
          )}

          <div className="modal-content-wrapper">
            <div className="modal-content">
              {title && (
                <>
                  <p className="r-subtitle-1 modal-title">{title}</p>
                </>
              )}
              <div className="model-custom-content">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletModal;
